(() => {
  const mounted = new WeakSet();
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
  function mount(root = document) {
    root.querySelectorAll('[data-rs2-pixeldex]').forEach(dex => {
      if (mounted.has(dex)) return;
      mounted.add(dex);
      const cards = [...dex.querySelectorAll('[data-rs2-dex-card]')];
      const search = dex.querySelector('[data-rs2-dex-search]');
      const sort = dex.querySelector('[data-rs2-dex-sort]');
      const grid = dex.querySelector('.rs2-dex-cards');
      const count = dex.querySelector('[data-rs2-dex-count]');
      const empty = dex.querySelector('[data-rs2-dex-empty]');
      const reset = dex.querySelector('[data-rs2-dex-reset]');
      if (!cards.length) return;
      const collator = new Intl.Collator(document.documentElement.lang || undefined, {numeric: true, sensitivity: 'base'});
      const number = card => /^\d+$/.test(card.dataset.number.trim()) ? Number(card.dataset.number) : Infinity;
      function sortCards() {
        cards.sort((a, b) => {
          if (sort.value === 'number') {
            const difference = number(a) - number(b);
            if (difference) return difference;
          }
          return collator.compare(a.dataset.name, b.dataset.name);
        });
        cards.forEach(card => grid.appendChild(card));
      }
      function filter() {
        const query = normalize(search.value);
        let visible = 0;
        cards.forEach(card => {
          const matches = normalize(`${card.dataset.name} ${card.dataset.number}`).includes(query);
          card.hidden = !matches;
          if (matches) visible++;
        });
        count.textContent = `${visible} / ${cards.length} ${count.dataset.label}`;
        empty.hidden = visible !== 0;
        reset.disabled = !search.value && sort.value === 'number';
      }
      search.addEventListener('input', filter);
      sort.addEventListener('change', () => { sortCards(); filter(); });
      reset.addEventListener('click', () => { search.value = ''; sort.value = 'number'; sortCards(); filter(); search.focus(); });
      dex.querySelector('.rs2-dex-tools').hidden = false;
      sortCards();
      filter();
    });
    root.querySelectorAll('[data-rs2-product-slider]').forEach(slider => {
      if (mounted.has(slider)) return;
      mounted.add(slider);
      const row = slider.querySelector('.rs2-product-row');
      const previous = slider.querySelector('[data-rs2-products-prev]');
      const next = slider.querySelector('[data-rs2-products-next]');
      const controls = slider.querySelector('.rs2-slider-controls');
      function update() {
        const overflow = row.scrollWidth - row.clientWidth;
        controls.hidden = overflow <= 2;
        previous.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= overflow - 2;
      }
      function move(direction) {
        row.scrollBy({left: direction * row.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      row.addEventListener('scroll', update, {passive: true});
      const observer = new ResizeObserver(() => {
        if (!row.isConnected) { observer.disconnect(); return; }
        update();
      });
      observer.observe(row);
      update();
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
